export default {
    name: "AlertsByCategoryChartWidget",
    type: "ChartWidget",
    description: "Shows the distribution of alerts by category.",
    roles: ["appUser"],
    widget: {
        title: "Alerts By Category",
        size: "medium",
        chartType: "doughnut",
        dataProvider: {
            main: {
                rpc: "SonarRpc.getAlertsByCategory"
            }
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',
                },
                title: {
                    display: false,
                    text: 'Alerts By Category'
                }
            }
        }
    }
};